import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { PlacanjeRacuna } from './placanje-racuna';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-placanje-racuna',
  templateUrl: './placanje-racuna.component.html',
})

export class PlacanjeRacunaComponent 
extends BaseModalContainer<PlacanjeRacuna>
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<PlacanjeRacuna>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) { 
    super(modalContainerService, activatedRoute, modalService, userService);
  } 

  ngOnInit() {
  }

}
